import { useRef } from 'react';
import { IonContent, IonFooter, IonToolbar } from '@ionic/react';
import CheckoutScreen from '../../../../pages/CheckoutScreen';
import PayButton from '../../../../components-library/payment/buttons/PayButton';
import { CheckoutInfoBagHandle, SectionType } from '../../../../components-library/checkout/sections/CheckoutInfoBag';
import PaymentCoordinator from '../../../../components-library/payment/PaymentCoordinator';
import PageHeader from '../../components/headers/PageHeader';
import { useTranslation } from 'react-i18next';
import CheckoutButton from '../../../../components-library/buttons/CheckoutButton';

const Content = (): JSX.Element => {
  const checkoutScreenRef = useRef<CheckoutInfoBagHandle>(null);
  const onCheckoutClick = (section: SectionType, open: boolean): void => {
    checkoutScreenRef.current?.toggleSection(section, open);
  };

  return (
    <>
      <CheckoutScreen ref={checkoutScreenRef} className="pb-[230px]" />
      <IonFooter className="">
        <IonToolbar className="ion-color !p-0 [&::part(container)]:p-0 bg-white fixed bottom-0 w-full safe-area-bottom">
          <CheckoutButton hideCashback>
            <PayButton toggleCheckoutSection={onCheckoutClick} className="!rounded-lg !font-semibold" />
          </CheckoutButton>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

const CheckoutPage = (): JSX.Element => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:CheckoutPage' });

  return (
    <>
      <PageHeader title={t('title')} />
      <IonContent className="safe-area-bottom">
        <PaymentCoordinator>
          <Content />
        </PaymentCoordinator>
      </IonContent>
    </>
  );
};

export default CheckoutPage;
